import * as React from "react";
import { Button } from "@utdanningsdirektoratet/button";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { Icon } from "@utdanningsdirektoratet/icon";
import styles from "./Popin.module.less";

import { close } from "./PopinManager";

type PopinFooterProps = {
  className?: string;
  popinId: string;
  saveButton?: string | React.ReactNode;
  saveButtonProps?: React.ComponentProps<typeof Button>;
  cancelButtonProps?: React.ComponentProps<typeof Button>;
  cancelButton?: string | React.ReactNode | boolean;
  onSave?: (callback: () => void) => void;
  onCancel?: (callback: () => void) => void;
  children?: React.ReactNode;
  loading?: boolean;
};

const PopinFooter: React.FC<PopinFooterProps> = ({
  className,
  popinId,
  onSave,
  onCancel = (cb) => cb(),
  loading,
  saveButtonProps,
  cancelButtonProps,
  saveButton = "Lagre",
  cancelButton = onSave ? "Avbryt" : "Lukk",
  children,
}) => {
  if (cancelButton === false && !children) return null;
  return (
    <footer className={cls(styles.popinFooter, className)}>
      {onSave && saveButton && (
        <Button primary disabled={loading} {...saveButtonProps} onClick={() => onSave(() => close(popinId))}>
          {loading && <Icon icon="spinner" placement="before" />}
          {saveButton}
        </Button>
      )}
      {cancelButton && (
        <Button disabled={loading} {...cancelButtonProps} onClick={() => onCancel(() => close(popinId))}>
          {cancelButton}
        </Button>
      )}
      {children}
    </footer>
  );
};

export default PopinFooter;
